
const routes = [
    {
      path: "products",
      name: "products_page",
      component: () => import("@/modules/products/views/ProductsListPage.vue") ,
    },
];

export default routes;
